import { useEffect, useState } from "react";
import { Bot, Sparkles, Users, CalendarDays, ArrowRight } from "lucide-react";
import { http } from "@/lib/api";

const HERO = "https://images.unsplash.com/photo-1599158150601-1417ebbaafdd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

function Stat({ testid, icon: Icon, title, value, sub, color, delay }) {
  return (
    <div data-testid={testid} className="panel panel-hover p-6 fade-up" style={{ animationDelay: `${delay}ms` }}>
      <div className="flex items-center justify-between text-slate-400 text-xs uppercase tracking-wider font-semibold">
        {title} <Icon size={18} style={{ color }} />
      </div>
      <div className="font-display text-4xl font-extrabold mt-4">{value}</div>
      <div className="text-sm text-slate-400 mt-1">{sub}</div>
    </div>
  );
}

export default function Overview({ goTo }) {
  const [s, setS] = useState(null);
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    http.get("/stats").then((r) => setS(r.data));
    http.get("/predictions").then((r) => setRecent(r.data.slice(0, 6)));
  }, []);

  return (
    <div className="space-y-10">
      <section className="panel fade-up min-h-[260px] flex items-end" style={{ backgroundImage: `linear-gradient(90deg,#0A0F1D 25%,rgba(10,15,29,.55)),url(${HERO})`, backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="p-8 sm:p-10 max-w-2xl">
          <span className="font-mono text-xs text-[var(--gold)] tracking-widest">STAGIONE 2026/27 · {s?.competitions ?? "–"} COMPETIZIONI</span>
          <h1 className="font-display text-5xl sm:text-6xl font-extrabold uppercase leading-[0.9] mt-3">Il pronostico giusto,<br />prima del fischio.</h1>
          <p className="text-slate-300 mt-4">Analisi AI su Serie A, Premier League, Liga, Bundesliga, Champions League e Mondiali, consegnata direttamente su Telegram.</p>
          <div className="flex flex-wrap gap-3 mt-6">
            <button data-testid="hero-go-fixtures-btn" onClick={() => goTo("fixtures")} className="btn btn-gold">Genera pronostici <ArrowRight size={16} /></button>
            <a data-testid="hero-open-bot-link" href={`https://t.me/${s?.bot_username || ""}`} target="_blank" rel="noreferrer" className="btn btn-tg"><Bot size={16} /> Apri il bot</a>
          </div>
        </div>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        <Stat testid="bot-status-card" icon={Bot} title="Stato Bot Telegram" value={s ? (s.bot_running ? "Attivo" : "Offline") : "…"} sub={s?.bot_username ? `@${s.bot_username}` : "—"} color={s?.bot_running ? "#10B981" : "#EF4444"} delay={0} />
        <Stat testid="predictions-count-card" icon={Sparkles} title="Pronostici Generati" value={s?.predictions ?? "…"} sub="Claude AI" color="#EAB308" delay={80} />
        <Stat testid="subscribers-count-card" icon={Users} title="Iscritti al Bot" value={s?.subscribers ?? "…"} sub={`${s?.pending ?? 0} in attesa di approvazione`} color="#229ED9" delay={160} />
        <Stat testid="competitions-card" icon={CalendarDays} title="Competizioni" value={s?.competitions ?? "…"} sub="Campionati, coppe e nazionali" color="#0284C7" delay={240} />
      </section>

      <section>
        <h2 className="font-display text-3xl font-bold uppercase mb-4">Ultimi pronostici</h2>
        {recent.length === 0 ? (
          <p data-testid="no-recent-predictions" className="text-slate-400">Nessun pronostico ancora. Vai su Calendario & Pronostici per generarne uno.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {recent.map((p) => (
              <div key={p.match_id} data-testid={`recent-prediction-${p.match_id}`} className="panel panel-hover p-5 flex items-center justify-between">
                <div>
                  <div className="font-semibold">{p.home} – {p.away}</div>
                  <div className="text-xs text-slate-400 font-mono mt-1">{p.competition_name} · {p.round_label} · {p.data.over_under}</div>
                </div>
                <div className="text-right">
                  <div className="font-display text-3xl font-extrabold text-[var(--gold)]">{p.data.esito}</div>
                  <div className="text-xs text-slate-400">{p.data.confidenza}%</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
